import styled from '@emotion/styled'

export const StyledToggle = styled.div`
  cursor: pointer;
  font-size: 0.85em;
  text-decoration: underline;
`
